import React from 'react';
import { ShieldCheck, Clock, ThumbsUp } from 'lucide-react';
import { motion } from 'framer-motion';

const badges = [
  {
    icon: ShieldCheck,
    title: 'Licensed & Insured',
    description: 'All work backed by comprehensive coverage'
  },
  {
    icon: Clock,
    title: 'Same-Day Service',
    description: 'Fast response when you need us most'
  },
  {
    icon: ThumbsUp,
    title: 'Satisfaction Focused',
    description: 'Your happiness is our top priority'
  }
];

export const Why = () => {
  return (
    <section id="why-us" className="py-16 sm:py-20 lg:py-24 presidential-gradient">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-semibold text-white mb-4">
            Why <span className="bg-gradient-to-r from-orange-600 via-orange-700 to-amber-800 bg-clip-text text-transparent">Re</span>modWorks?
          </h2>
          <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto">
            Trusted by homeowners across Northeast Ohio
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {badges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <motion.div
                key={badge.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-slate-800/50 backdrop-blur border border-slate-700 rounded-xl p-6 text-center hover:bg-slate-800/70 hover:border-slate-600 transition-all duration-200"
              >
                <div className="h-14 w-14 rounded-full bg-slate-400/10 flex items-center justify-center mx-auto mb-4">
                  <Icon className="h-7 w-7 text-slate-300" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {badge.title}
                </h3>
                <p className="text-sm text-slate-400">
                  {badge.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};